export const named_colors = {
  red: '#ff4243',
  orange: '#ff8601',
  yellow: '#ffcd3f',
  green: '#69e100',
  blue: '#33b6e7',
  dark_blue: '#44f',
  purple: '#8b36bb',
  pink: '#ff41e8',
}
export const named_icons = {
  dog: '🐶',
  cat: '🐱',
  fox: '🦊',
  fish: '🐟',
  frog: '🐸',
  ladybug: '🐞',
}
export const default_player_profiles = [{
  color: named_colors.dark_blue,
  icon: named_icons.dog,
}, {
  color: named_colors.red,
  icon: named_icons.cat,
}, {
  color: named_colors.green,
  icon: named_icons.fox,
}, {
  color: named_colors.yellow,
  icon: named_icons.fish,
}, {
  color: named_colors.purple,
  icon: named_icons.frog,
}, {
  color: named_colors.orange,
  icon: named_icons.ladybug,
}]

export const profile_colors = Object.values(named_colors)
export const profile_icons = Object.values(named_icons)
